import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ApprovalsService } from '../services/approvals.service';
import type { ApprovalFilters } from '../types/approvals.types';
import { useState } from 'react';
import { toast } from 'sonner';

export function useApprovals(companyId: string, userId: string, initialType: 'pending' | 'my-requests' | 'history' = 'pending') {
  const [filters, setFilters] = useState<ApprovalFilters>({
    type: initialType,
    status: 'all'
  });

  const query = useQuery({
    queryKey: ['approvals', companyId, userId, filters],
    queryFn: () => ApprovalsService.getApprovals(companyId, userId, filters),
    enabled: !!companyId && !!userId,
  });

  return {
    requests: query.data || [],
    isLoading: query.isLoading,
    filters,
    setFilters
  };
}

export function useApprovalDetail(id?: string, userId?: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['approvals', 'detail', id],
    queryFn: () => ApprovalsService.getApprovalDetail(id!),
    enabled: !!id,
  });

  const actionMutation = useMutation({
    mutationFn: ({ action, comment }: { action: string; comment?: string }) => 
      ApprovalsService.performAction(id!, action, userId!, comment),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['approvals'] });
      queryClient.invalidateQueries({ queryKey: ['approvals', 'detail', id] });
      toast.success(`Đã thực hiện ${variables.action} thành công`);
    },
    onError: (error: any) => {
      toast.error('Lỗi thực hiện: ' + error.message);
    }
  });

  return {
    detail: query.data,
    isLoading: query.isLoading,
    performAction: actionMutation.mutateAsync,
    isProcessing: actionMutation.isPending
  };
}
